export const WHITE = '#FFFFFF'
export const OFFWHITE = '#F9F9F9'
export const WHITE_DARK = '#EFEFEF'
export const YELLOW = '#FDF99B'
export const YELLOW_DARK = '#F9F116'
export const BLUE = '#9CE8E8'
export const BLUE_DARK = '#8EE8E8'
export const RED = '#FFA6A6'
export const RED_DARK = '#F39393'
export const SELECT = '#44C0FF'
